import css from './Radio.module.scss';
import classNames from 'classnames';

const Radio = ({ val }) => {
    return <div className={classNames(css.radio, { [css.radioSelected]: !!val })}></div>;
};

export default Radio;
